import { OfferItemCondition } from 'schema-dts';

export const NEW_CONDITION_IDS = ['10', '9'];

export const getGoogleShoppingCondition = (conditionId: string | number): OfferItemCondition => {
  return NEW_CONDITION_IDS.includes(String(conditionId))
    ? 'https://schema.org/NewCondition'
    : 'https://schema.org/UsedCondition';
};
